import { CustomBox } from "components";
import { SubscriptionRetentionRateIcon } from "pages/internal-dashboard/icons";
import { getGrowthTrends, getUserRate } from "../../helpers";

export function SubscriptionRetentionRate({
  data,
  isLoading,
  totalUsers,
}: any) {
  const { today, thisWeek, thisMonth, thisYear, total } = data || {};

  const growthTrends = getGrowthTrends(data);

  return (
    <CustomBox
      loading={isLoading}
      color="#CDD5DE"
      title="Subscription Retention Rate"
      userCount={getUserRate({ value: total, total: totalUsers?.total }) + "%"}
      boxData={{
        label: "User Retention",
        description:
          "The percentage of users who continue their subscription and renewed subscription over a specific period.",
        todayCount:
          getUserRate({ value: today, total: totalUsers?.today }) + "%",
        weekCount:
          getUserRate({ value: thisWeek, total: totalUsers?.thisWeek }) + "%",
        monthCount:
          getUserRate({ value: thisMonth, total: totalUsers?.thisMonth }) + "%",
        yearCount:
          getUserRate({ value: thisYear, total: totalUsers?.thisYear }) + "%",
        icon: SubscriptionRetentionRateIcon,
      }}
      percentages={growthTrends}
    />
  );
}
